import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";
import BaseUrl from "./Baseurl/Api.js";

// Custom hook to detect mobile
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};

const HeroSlider = () => {
  const [banners, setBanners] = useState([]);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) {
      // Desktop: fetch banners from API
      BaseUrl.get("/api/get_banner")
        .then((res) => {
          if (res.data.status === "success") {
            setBanners(res.data.banner_data);
          }
        })
        .catch((err) => console.error("Error fetching banners:", err));
    } else {
      // Mobile: use static banners
      setBanners([
        {
          image:
            "https://ueirorganic.com/cdn/shop/files/Mobile_5.jpg?v=1749731709&width=1500",
          title: "Delicious Sweets Every Day",
        },
        {
          image:
            "https://ueirorganic.com/cdn/shop/files/3_3.jpg?v=1758111253&width=750",
          title: "Fresh & Premium Quality",
        },
        {
          image:
            "https://ueirorganic.com/cdn/shop/files/Mobile_8.jpg?v=1752125781&width=750",
          title: "Sweeten Your Moments",
        },
      ]);
    }
  }, [isMobile]);

  const desktopSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
  };

  const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <section
      className="hero-slider"
      style={{ marginTop: isMobile ? "0px" : "-13px" }} // desktop: 0px, mobile: 20px
    >
      {banners.length === 0 ? (
        <p className="text-center py-5">Loading banners...</p>
      ) : (
        <Slider {...(isMobile ? mobileSettings : desktopSettings)}>
          {banners.map((banner, index) => (
            <div
              key={index}
              className={isMobile ? "hero-slide-mobile" : "hero-slide"}
            >
              <div
                style={{
                  backgroundImage: `url(${
                    banner.image
                      ? isMobile
                        ? banner.image
                        : `${BaseUrl.defaults.baseURL}/bannerimage/${banner.image}`
                      : "/fallback.jpg"
                  })`,
                  backgroundSize: isMobile ? "cover" : "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                  height: isMobile ? "550px" : "650px", // desktop: less height
                  width: "100%",
                  position: "relative",
                  borderRadius: isMobile ? "12px" : "0px",
                  overflow: "hidden",
                }}
              >
                {banner.title && (
                  <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={textVariants}
                    style={{
                      position: "absolute",
                      bottom: isMobile ? "8px" : "50px",
                      left: isMobile ? "15px" : "60px",
                      color: "#fff",
                      backgroundColor: isMobile
                        ? "rgba(0,0,0,0.5)"
                        : "rgba(0,0,0,0.4)",
                      padding: isMobile ? "6px 12px" : "15px 30px",
                      borderRadius: "8px",
                      fontSize: isMobile ? "0.95rem" : "1.8rem",
                      fontWeight: "700",
                      maxWidth: isMobile ? "90%" : "60%",
                    }}
                  >
                    {banner.title}
                  </motion.div>
                )}
              </div>
            </div>
          ))}
        </Slider>
      )}
    </section>
  );
};

export default HeroSlider;
